module.exports = __webpack_public_path__ + "static/50-ae25c379d037999f36a73e1b82cf901a.jpg";